WL.registerComponent('hide-on-querystring', {    
}, {
    start: function() {
        if(window.location.href.endsWith('?ispwa')){
            this.object.getComponent('mesh').active = false;
            this.object.getComponent('collision').active = false;
            this.object.getComponent('zesty-banner').active = false;
        }
    },
});
